import { apiClient } from './authApi';
import { createAdminUpdateBody } from '@carboncare/schemas';
import { preflight } from './schemaPreflight';

export interface AdminUpdate {
  id: string;
  title: string;
  body: string;
  send_via_email: boolean;
  send_via_notification: boolean;
  target_user_types?: number[] | null; // AccountType values - if null, all users get the update
  target_company_ids?: number[] | null; // List of company IDs - if null, all companies get the update
  custom_emails?: string[] | null; // List of custom emails
  scheduled_at: Date | null;
  status: 'pending' | 'processing' | 'sent' | 'failed';
  created_by: number | null;
  created_at: Date;
  updated_at: Date;
  error_message?: string;
}

export interface CreateAdminUpdateData {
  title: string;
  body: string;
  send_via_email: boolean;
  send_via_notification: boolean;
  target_user_types?: number[] | null; // AccountType values - if null, all users get the update
  target_company_ids?: number[] | null; // List of company IDs - if null, all companies get the update
  custom_emails?: string[] | null; // List of custom emails
  scheduled_at?: string | null;
}

export const adminUpdatesApi = {
  // Create a new update/announcement
  create: async (data: CreateAdminUpdateData): Promise<AdminUpdate> => {
    preflight(createAdminUpdateBody, data);
    const response = await apiClient.post('/admin-updates', data);
    return response.data.data;
  },

  // Get all updates (paginated)
  getAll: async (params?: { page?: number; limit?: number; sortBy?: string; sortOrder?: 'asc' | 'desc' }): Promise<{ data: AdminUpdate[]; total: number; page: number; limit: number }> => {
    const response = await apiClient.get('/admin-updates', { params });
    return {
      data: response.data.data,
      total: response.data.total ?? response.data.data.length,
      page: response.data.page ?? params?.page ?? 1,
      limit: response.data.limit ?? params?.limit ?? 10,
    };
  },

  // Get update by ID
  getById: async (id: string): Promise<AdminUpdate> => {
    const response = await apiClient.get(`/admin-updates/${id}`);
    return response.data.data;
  },

  // Delete an update (only pending updates can be deleted)
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin-updates/${id}`);
  },
};
